var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduledMaintenanceOptimization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5579 20.4732H20.2105C19.0105 17.2101 17.2 11.6101 16.2316 5.16795H16.8421C17.1789 5.16795 17.4316 4.89427 17.4316 4.57848V3.67321C17.4316 3.33637 17.1579 3.08374 16.8421 3.08374H7.13684C6.8 3.08374 6.54737 3.35742 6.54737 3.67321V4.55742C6.54737 4.89427 6.82105 5.1469 7.13684 5.1469H7.74737C6.77895 11.589 4.98947 17.2101 3.78947 20.4732H2.44211C2.18947 20.4732 2 20.6627 2 20.9153V22.1153C2 22.368 2.18947 22.5574 2.44211 22.5574H21.5579C21.8105 22.5574 22 22.368 22 22.1153V20.9153C22 20.6627 21.8105 20.4732 21.5579 20.4732ZM12.9895 12.2206L13.9579 12.1364C14.3789 12.0943 14.6737 12.5785 14.4421 12.9364L12 16.8101C11.7053 17.2732 10.9895 17.0416 11.0316 16.4943L11.2 14.389C11.2 14.2837 11.1158 14.1785 11.0105 14.1995L10.0421 14.2837C9.62105 14.3258 9.32632 13.8416 9.5579 13.4837L12 9.61006C12.2947 9.1469 13.0105 9.37848 12.9684 9.92585L12.8 12.0311C12.8 12.1364 12.8842 12.2416 12.9895 12.2206Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledMaintenanceOptimization);
export default __webpack_public_path__ + "static/media/scheduled-maintenance-optimization.892047f7.svg";
export { ForwardRef as ReactComponent };